export default __webpack_public_path__ + "static/media/public_logo.6382ecd7.svg";